import { APP_CONSTANTS } from '../AppConstants';

const identityV4Url = `${window.__ENV__.BFF_URL}/identity/v4/member/authorize`;
const ssoAuthorizeEndpoint = `${window.__ENV__.BFF_URL}/sso/authorize`;

/**
 * Authorize a member and return a full member JWT
 * @param {Object} partialJWT - JWT to be passed for gb-authorization header
 * @param {string} clientNumber - requested clientNumber to authorize with
 * @param {string} certificate - requested certificate to authorize with
 * @param {string} group - requested group to authorize with
 * @param {string} transactionId - transactionId to be passed for mli-session-correlation-id header
 */
export const getFullJwt = async (partialJWT, clientNumber, certificate, group, entityId, transactionId) => {
    const method = 'POST';
    const headers = {
        'Content-Type': 'application/json',
        'mli-session-correlation-id': transactionId,
        'mli-channel': 'web',
        'gb-authorization': partialJWT,
    };
    const body = {
        clientNumber,
        certificate,
        group,
    };

    // Determine the appropriate endpoint based on how member initially authenticated
    const isSso = Boolean(entityId);
    const authorizeUrl = isSso ? ssoAuthorizeEndpoint : identityV4Url;

    try {
        const response = await fetch(authorizeUrl, {
            method,
            headers,
            ...(!isSso && { body: JSON.stringify(body) }),
        });
        const fullJwtResponseBody = await response.json();

        if (!response.ok) {
            const errorMessage = `getFullJwt: HTTP error ${response.status} - ${
                response.statusText
            }. Error: ${JSON.stringify(fullJwtResponseBody)}`;
            throw new Error(errorMessage);
        }

        // Calculating clock correction for session expiration management
        const serverTimestamp = fullJwtResponseBody['gb-server-timestamp'];
        sessionStorage.setItem(APP_CONSTANTS.MPROFILE_SESSION_OFFSET, Date.now() - serverTimestamp);

        return fullJwtResponseBody;
    } catch (error) {
        // If it's already our custom error, re-throw it
        if (error.message?.startsWith('getFullJwt:')) {
            throw error;
        }

        throw new Error('getFullJwt: Error occurred with calling authorize endpoint');
    }
};
